import AppText from './AppText.vue';

export default AppText;



// WEBPACK FOOTER //
// ./src/uikit/typography/Text/index.ts